import FeedbackComment from "components/card/RespondBackCard";
import React, { useEffect, useState } from "react";
import { getReferralRespondBacksByReferralId } from "services/assetRecoveryService";
import { ReferralRespondBack } from "types";
import { errorHandler, formatDate } from "utils/helper";
import FeedBackForm from "./FeedBackForm";
import {
  getAssetAppealRespondBacksByAppealId,
  getRespondentAssetAppealFeedbacks,
} from "services/assetAppealService";
import { useTooltip } from "context/TooltipProvider";

function RespondBackSection({
  referralId,
  fileRowProps,
  appealId,
  type,
}: {
  referralId: string;
  fileRowProps: any;
  appealId?: string;
  type: string;
}) {
  const [request, setRequests] = useState<ReferralRespondBack[]>();
  const [feedbacks, setFeedbacks] = useState<ReferralRespondBack[]>([]);
  const [respondbackReferralRespondBacks, setRespondbackFeedbacks] = useState<
    ReferralRespondBack[]
  >([]);
  const [state, setState] = useState("feedback");
  const { showTooltip } = useTooltip();
  useEffect(() => {
    if (type === "appeal") {
      if (appealId) {
        getAssetAppealRespondBacksByAppealId(appealId as string)
          .then(setRequests)
          .catch((error) => {
            showTooltip(errorHandler(error));
          });
      }
    } else if (type === "appeal-respondent") {
      if (appealId) {
        getRespondentAssetAppealFeedbacks(appealId as string)
          .then(setRequests)
          .catch((error) => {
            showTooltip(errorHandler(error));
          });
      }
    } else {
      getReferralRespondBacksByReferralId(referralId as string)
        .then(setRequests)
        .catch((error) => {
          showTooltip(errorHandler(error));
        });
    }
  }, [appealId, referralId, type]);

  // Filter when request changes
  useEffect(() => {
    if (request) {
      setFeedbacks(
        request.filter((feedback) => feedback?.feedback_type === "normal")
      );
      setRespondbackFeedbacks(
        request.filter((feedback) => feedback?.feedback_type === "respond_back")
      );
    }
  }, [request]);
  return (
    <div className=" flex flex-col bg-white rounded-lg shadow-md p-6  max-h-screen w-full">
      <div className="flex gap-4 items-center pb-2 mb-4 border-b-2">
        <p
          onClick={() => setState("feedback")}
          className={`cursor-pointer font-semibold ${
            state === "feedback"
              ? "text-base text-white bg-black p-2 rounded-lg"
              : "text-base text-gray-400"
          }`}
        >
          Feedback Section
        </p>
        <p
          onClick={() => setState("respondback")}
          className={`cursor-pointer font-semibold ${
            state === "respondback"
              ? "text-base text-white bg-black p-2 rounded-lg"
              : "text-base text-gray-400"
          }`}
        >
          Respond Back Section
        </p>
      </div>
      {/* Feedback Comments */}
      <div className="overflow-y-scroll scrollbar-hide flex-1 space-y-6 mb-6">
        {state === "feedback" ? (
          <>
            {feedbacks.map((feedback: any) => (
              <FeedbackComment
                key={feedback.id}
                name={feedback.given_by_name}
                role={feedback.role}
                commentedDate={formatDate(feedback.created_at)}
                comment={feedback.feedback_summary}
              />
            ))}
            {feedbacks.length === 0 && (
              <p className="text-center my-auto">No Messages Yet</p>
            )}
          </>
        ) : (
          <>
            {respondbackReferralRespondBacks
              ?.slice()
              .reverse()
              .map(
                (feedback: any) =>
                  feedback.feedback_type !== "stakeholder_request" && (
                    <FeedbackComment
                      key={feedback.id}
                      name={feedback.given_by_name || ""}
                      role={feedback.role}
                      commentedDate={formatDate(feedback.feedback_date)}
                      comment={feedback.feedback_summary}
                      file={feedback.feedback_documents}
                      status={feedback.respondback_type}
                      fileRowProps={fileRowProps}
                    />
                  )
              )}
            {respondbackReferralRespondBacks?.length === 0 && (
              <p className="text-center my-auto">
                No Respond Back Feedback Yet
              </p>
            )}
          </>
        )}
      </div>
      {/* Write Back Response */}
      {
        state === "feedback" && (
          <FeedBackForm
            request={request}
            onSubmit={setFeedbacks}
            referralId={referralId as string}
            appealId={appealId as string}
            type={type}
          />
        )
        // <></>
      }
    </div>
  );
}

export default RespondBackSection;
